module.exports = __webpack_public_path__ + "img/Sibiu_8_kl.dccb07e5.jpg";